import { lazy } from 'react';

import { Route } from 'react-router-dom';
import routeUrlProvider, {
  THIRD_PARTY_PAYMENT,
  THIRD_PAYMENT_PENDING,
} from 'constants/route-paths';

import { PlacingPayment as PlacingPaymentProvider } from 'contexts/placingPayment';

const ThirdPartyPaymentWithContext = lazy(() => import('pages/ThirdPartyPayment'));
const ThirdPaymentPending = lazy(() => import('../pages/ThirdPaymentPending'));

export default [
  <Route exact path={routeUrlProvider.getForRoute(THIRD_PARTY_PAYMENT)}>
    <PlacingPaymentProvider>
      <ThirdPartyPaymentWithContext />
    </PlacingPaymentProvider>
  </Route>,

  <Route
    exact
    path={routeUrlProvider.getForRoute(THIRD_PAYMENT_PENDING)}
    component={ThirdPaymentPending}
  />,
];
